<template>
  <router-link
    class="notification-t8x nounderline"
    :to="`/p/checkup/${entity.RecordNo}`"
  >
    <div class="row no-gutters align-items-center">
      <div class="col-auto text-primary border-right p-3 h-100">
        <div
          :style="{
            backgroundImage: `url('/img/checkup.jpg')`,
          }"
          class="photo d-inline-block shadow-sm"
        ></div>
      </div>
      <div class="col mb-2 p-3">
        <CheckupLink :checkup="entity"></CheckupLink>
      </div>
    </div>
  </router-link>
</template>
<script>
import CheckupLink from '@/components/Checkups/Link.vue'
export default {
  components: {
    CheckupLink
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss">
.notification-t8x {
  .month {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 80px;
    font-size: 0.75em;
  }
  .day {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 44px;
    font-size: 2em;
  }
  svg {
    width: 75px !important;
    // height: 100px;
  }
}
</style>
<i18n>
{
  "ka": {
      "TreatmentItemCreated": "შეიქმნა",
      "TreatmentItemCancelled": "გაუქმდა",
      "Recommendation": "რეკომენდებული დანიშნულება",
      "Drug": "დაგენიშნა პრეპარატი"
  },
  "en": {
      "TreatmentItemCreated": "Created",
      "TreatmentItemCancelled": "Cancelled",
      "Recommendation": "Recommendation",
      "Drug": "Drug"
  }
}
</i18n>
